import React from 'react';
import { connect } from '../../connect';
import { signIn } from '../../actions';
import { IActionDispatch } from '../../actions/action-types';

function mapStateToProps({ auth }) {
	return { auth };
}

interface ISignInFormProps {
	dispatch?: IActionDispatch;
	auth?: {
		isProcessing?: boolean;
		error: string;
	};
	signInUrl?: string;
	location: URL;
	className?: string;
}

interface ISignInFormState {
	email: string;
	password: string;
}

@connect(mapStateToProps)
export class SignInForm extends React.Component<ISignInFormProps, ISignInFormState> {
	state: ISignInFormState = {
		email: '',
		password: '',
	};

	handleSignIn(event: React.FormEvent, { email, password }: ISignInFormState) {
		const { auth, dispatch } = this.props;
		event.preventDefault();

		if (dispatch && auth && !auth.isProcessing) {
			dispatch(signIn(email, password)).catch(() => null);
		}
	}

	handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
		const nextState = {};
		nextState[event.target.name] = event.target.value;
		this.setState(nextState);
	}

	renderSignInError(error?: string) {
		if (!error) {
			return null;
		}

		const {
			location: { pathname },
			auth,
		} = this.props;
		const authError = auth && auth.error;
		if (pathname === '/signin') {
			return <div className="error-text">{authError}</div>;
		}

		return <div>{authError}</div>;
	}

	render() {
		const { auth, signInUrl } = this.props;
		const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => this.handleInputChange(event);

		return (
			<form
				className="sign-in-form centered"
				method="post"
				action={signInUrl}
				onSubmit={event => this.handleSignIn(event, this.state)}
			>
				{this.renderSignInError(auth && auth.error)}
				{/* TODO: Fix this the next time the file is edited. */}
				{/* eslint-disable-next-line react/no-string-refs */}
				<input type="email" placeholder="Email" name="email" ref="emailInput" onChange={handleInputChange} />
				<input type="password" placeholder="Password" name="password" onChange={handleInputChange} />
				<button type="submit" disabled={auth && auth.isProcessing}>
					Sign In
				</button>
			</form>
		);
	}
}
